import { render, staticRenderFns } from "./PureText.vue?vue&type=template&id=0d2e179b&"
import script from "./PureText.vue?vue&type=script&lang=js&"
export * from "./PureText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports